import type { ChannelStats, MessagesStats } from '@pages/event/api/useFetchMessagesStats';

export interface ChannelMetric {
  label: string;
  count: number;
  percent: number;
  width: string;
  variant: 'default' | 'brand';
  hasErrors: boolean;
  isVisible: boolean;
}

export const getChannelPercent = (successCount: number, totalMessages: number): number => {
  if (totalMessages === 0) {
    return 0;
  }

  return Math.round((successCount / totalMessages) * 100);
};

export const getChannelWidth = (successCount: number, totalMessages: number): string => {
  if (successCount === 0 || totalMessages === 0) {
    return 'max-content';
  }

  return `${getChannelPercent(successCount, totalMessages)}%`;
};

export const buildTotalMetric = (totalMessages: number): ChannelMetric => ({
  label: 'К отправке',
  count: totalMessages,
  percent: 100,
  width: '100%',
  variant: 'default',
  hasErrors: false,
  isVisible: true,
});

export const buildChannelMetric = (channelStats: ChannelStats, totalMessages: number, label: string): ChannelMetric => {
  const count = channelStats.successCount;

  return {
    label,
    count,
    percent: getChannelPercent(count, totalMessages),
    width: getChannelWidth(count, totalMessages),
    variant: 'brand',
    hasErrors: channelStats.errorCount > 0,
    isVisible: channelStats.successCount > 0 || channelStats.errorCount > 0 || channelStats.pendingCount > 0,
  };
};

export const buildStatisticsMetrics = (messagesStats: MessagesStats) => {
  const { totalMessages, emailStats, smsStats, vkStats } = messagesStats;
  const channelStats = [emailStats, smsStats, vkStats];

  return {
    total: buildTotalMetric(totalMessages),
    vkTeams: buildChannelMetric(vkStats, totalMessages, 'Отправлено сообщений VK Teams'),
    email: buildChannelMetric(emailStats, totalMessages, 'Отправлено e-mail'),
    sms: buildChannelMetric(smsStats, totalMessages, 'Отправлено СМС'),
    hasUnsentTickets: channelStats.some((stats) => stats.errorCount > 0 || stats.pendingCount > 0),
  };
};
